import $ from 'jquery';
import TweenMax from "gsap";
var banner;

$(window).on("scroll", function() {
  scrollAnime();
});
$(window).on("resize", function() {
  if ($(window).innerWidth() >= 750) {
    edit(1);
  }
  scrollAnime();
});
$(window).on("load", function() {
  edit(2);
  $(".loading").fadeOut(600, function() {
    $(".container").css("opacity", "1");
    scrollAnime();
  });

  banner = $(".mv_flex").offset().top + $(".mv_flex").height();
  console.log(banner)
});



function edit(p) {
  $(".mv").height(window.innerHeight - $(".header").outerHeight() + "px");
}

$('.modal_dialog_close').click(function() {
  $(".modal, .modal_dialog").fadeOut(300, function() {
  });
});
$('.openModal').click(function() {
  var no = $(this).data("no");
  $(".modal").fadeIn(300, function() {

    $(".modal_dialog[data-no='" + no + "']").fadeIn(300);
  });
});

$('a.scroller[href^="#"]').on("click", function() {
  var target = $($(this).attr("href"));
  var position = target.offset().top;

  $('body,html').stop().animate({
    scrollTop: position
  }, 500);
  return false;
});

window.addEventListener('DOMContentLoaded', () => {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

  anchorLinksArr.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const targetId = link.hash;
      const targetElement = document.querySelector(targetId);
      const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
      window.scrollTo({
        top: targetOffsetTop,
        behavior: "smooth"
      });
    });
  });
});

function scrollAnime() {
  var windowHeight = $(window).innerHeight(),
    windowWidth = $(window).innerWidth(),
    topWindow = $(document).scrollTop(),
    docHeight = $(document).innerHeight(),
    footerPosition = $(".footer").offset().top,
    fadeH = 200
    ;

  if (topWindow > banner) {
    if (topWindow > (footerPosition - windowHeight)) {
      $(".mv_flex").fadeOut(500, function() {
        $(".mv_flex").removeClass("follow");
      });
    } else {
      $(".mv_flex").fadeIn(500);
    }
    $(".mv_flex").addClass("follow");
  } else {
    $(".mv_flex").removeClass("follow");
  }

  $('.fadein, .slidein').each(function() {
    var targetPosition = $(this).offset().top;

    fadeH = $(this).data("fadeheight") != undefined ? $(this).data("fadeheight") : 200;

    if (topWindow > targetPosition - windowHeight + (fadeH)) {
      $(this).addClass($(this).data("fadein"));
    }
  });
}
